import React from "react";

import { useFormContext } from "react-hook-form";

import { EmailPattern } from "@common/constants";
import { FormInputField } from "@components-shared/desktop/inputs";
import { useValueAvailabilityDebounce } from "@state/hooks/shared";

export default function OnboardingRegistrationEmail(props: {
	checkIsEmailAvailable: (data: string) => Promise<boolean>;
	labelClassName?: string;
}) {
	const { checkIsEmailAvailable, labelClassName } = props;

	const {
		formState: { errors },
		clearErrors,
	} = useFormContext();

	const debouncer = useValueAvailabilityDebounce();

	return (
		<FormInputField
			id="enterEmail"
			name="email"
			className="form__field u-mar--bottom--reset"
			labelClassName={labelClassName}
			label="registration:EMAIL_LABEL"
			inputClassName="input input--sml input"
			placeholder="registration:EMAIL_PLACEHOLDER"
			popoverMsg={"registration:EMAIL_DESCRIPTION"}
			maxLength={100}
			pattern={{
				value: EmailPattern,
				message: "registration:INVALID_EMAIL",
			}}
			validate={{
				isAvailable: async (value: string) => {
					if (errors?.["email"]) {
						clearErrors("email");
					}

					const isAvailable = await debouncer(
						value,
						checkIsEmailAvailable
					);

					return isAvailable || "registration:EMAIL_EXISTS";
				},
			}}
			required
		/>
	);
}
